module.exports = __webpack_public_path__ + "media/images/User_Avatar_2-e25da5e8e7123d9d49be2dabb282f687.png";